<div class="is-relative is-flex is-justify-center">
  <app-icon
      class="is-overlay is-flex is-justify-center text-32 is-family-semiBold has-text-centered"
      [name]="'warning-circle-composition-overlay'">
  </app-icon>
  <app-icon name="warning-circle-composition-background" class="text-red-alert has-margin-centered text-32"></app-icon>
</div>
